import { render, staticRenderFns } from "./BarcodeShower.vue?vue&type=template&id=1075d0c3&"
import script from "./BarcodeShower.vue?vue&type=script&lang=js&"
export * from "./BarcodeShower.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports